import React, {Fragment, useEffect, useState} from "react";
import {getDatabase, onValue, ref} from "firebase/database";
import _ from "lodash";
import {cannotResolveOptionType, workMode} from "_constants";
import {getCurrentUser, getWorkMode, refreshPage} from "_helpers";
import app from "../../../../../../firebase.config";
import MessageUnavailableModal from "../../../../../Vote/v2/MessageUnavailableModal";
import {buildCannotResolvePayload} from "../VoteUtils";
import {useDispatch} from "react-redux";
import {submitReason} from "../../Sections/FooterSection/CannotResolve/CannotResolveUtils";

export default function FirebaseMessageListener({message}) {
    const userWorkMode = getWorkMode();
    if(userWorkMode !== workMode.ACTIVE) {
        return <Fragment />;
    }
    const dispatch = useDispatch();
    const [activeMessage, setActiveMessage] = useState({});
    const [conversationAssignment, setConversationAssignment] = useState({});
    const { id } = getCurrentUser();
    const msgDataSourceId = _.get(message, 'msgDataSource.id');
    const externalParentId = _.get(message, 'externalParentId');
    const agentId = _.get(conversationAssignment, 'agentId');
    const assigneeId = _.get(conversationAssignment, 'assigneeId');
    const dbConversationId = _.get(conversationAssignment, 'conversationId');
    const dbMsgDataSourceId = _.get(conversationAssignment, 'msgDataSourceId');
    const conversationAssignmentId = `${msgDataSourceId}-${externalParentId}`;
    const dbConversationAssignmentId = `${dbMsgDataSourceId}-${dbConversationId}`;
    const sameAssignee = agentId === assigneeId;
    const sameConversation = conversationAssignmentId === dbConversationAssignmentId;
    const openModalOnAssignment = !sameAssignee && sameConversation;
    const isSameUser = id === _.get(activeMessage, 'lockedBy');
    const isSameMessage = _.get(activeMessage, 'id') === _.get(message, 'id');
    const isCollidedMessage = isSameMessage && !isSameUser;
    const openModalOnMessageCollision = (isCollidedMessage || activeMessage.actioned || activeMessage.hasEmployeeSeen || activeMessage.removedFromSource) || false;
    const openModal = openModalOnMessageCollision || openModalOnAssignment;

    useEffect(() => {
        const database = getDatabase(app);
        const activeMessagesRef = ref(database, `active_messages/${message.id}`);
        const conversationAssignmentRef = ref(database, `conversation_assignment/${conversationAssignmentId}`);
        onValue(activeMessagesRef, (snapshot) => {
            if(snapshot.exists()) {
                setActiveMessage(snapshot.val());
            }
        });
        onValue(conversationAssignmentRef, (snapshot) => {
            if(snapshot.exists()) {
                setConversationAssignment(snapshot.val());
            }
        });
        return database;
    },[]);

    useEffect(() => {
        if(openModalOnAssignment) {
            const optionType = cannotResolveOptionType.ASSIGNEE_CHANGED_ON_SOURCE;
            const payload = buildCannotResolvePayload(message, optionType);
            submitReason(dispatch, payload, optionType);
        }
    }, [openModalOnAssignment])

    const handleClose = (event, reason) => {
        if (reason === "backdropClick") return false;
        if (reason === "escapeKeyDown") return false;
        refreshPage();
    };

    return(
        <MessageUnavailableModal
            open={openModal}
            handleClose={handleClose}
            message={"This message is no longer available to work on"} />
    )
}